<title>{{ newsContentPage.htmlTitle }}</title>
<app-banner [banner]="newsContentPage.banner" [isCommonBanner]="true" [isDefaultPageBanner]="false"></app-banner>
<div class="container mt-5 mb-5 minheight">
  <app-news-content-page-section *ngIf="newsContentPage.introductionSections?.length" [sections]="newsContentPage.introductionSections"></app-news-content-page-section>
  <app-news-content-page-accordion-section *ngIf="newsContentPage.accordionSections?.length" [sections]="newsContentPage.accordionSections"></app-news-content-page-accordion-section>
  <app-news-content-page-table-section *ngIf="newsContentPage.tableSections" [tableSections]="newsContentPage.tableSections"></app-news-content-page-table-section>
  <app-news-content-page-section *ngIf="newsContentPage.belowNoteSections?.length" [sections]="newsContentPage.belowNoteSections"></app-news-content-page-section>

  <div *ngIf="newsContentPage.image && newsContentPage.imageSections">
    <div class="divide mb-5 row">
      <div class="col-sm-6 mt-2">
        <img src="{{ newsContentPage.image }}" />
      </div>
      <div class="col-sm-6 mt-2">
        <app-news-content-page-section [sections]="newsContentPage.imageSections"></app-news-content-page-section>
      </div>
    </div>
  </div>
</div>
